import styles from './CardSlider.module.scss';

export const CardSlider = ({ cards }: { cards: React.ReactNode[] }) => {
  return (
    <div className={styles.container}>
      <div className={styles.cardsContainer} data-testid='cards-container'>
        {cards.map(card => card)}
      </div>
    </div>
  );
};
